<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              .h6.basic800--text Edit Store

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              .label.basic600--text.text-uppercase.mt-2.mb-1 Store Categories
              v-combobox(v-if="categoryList.length > 0" v-model="categories" outlined :loading="categoriesSearchLoading" item-text="name" :search-input.sync="cetegorySearch" :items="categoryList" hide-selected hide-no-data chips dense placeholder="Type to search" hide-details multiple :menu-props="({ 'closeOnContentClick': false, 'maxHeight': category_keyboard ? '35%' : '45%' })" :type="category_keyboard ? 'text' : 'button'" background-color="basic200")
                template(v-slot:selection="{ attrs, item, select, selected }")
                  v-chip.mt-1.s2(outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close :color="basic600" :input-value="selected" @click:close="removeSales(item)")
                    span {{ item.name }}
                  //- v-chip.primary(v-bind="attrs" :input-value="selected" small close @click:close="removeSales(item)")
                  //-   strong {{ item.name }}
                template(v-slot:item="{ index, item }")
                  v-layout
                    v-list-item-content
                      v-list-item-title(v-text="item.name")
                v-btn close
              
              .cover-photo.d-flex.mt-6 
                h6.basic1000--text {{ $t('cover_photo') }}
                v-spacer
                div.file-layout(v-if="resizeImageFileUrl")
                  v-btn.button-Aa-tiny.custom-transform-class.text-none.px-2(color="textColorAccent" text small)
                    eva-icon.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="12" width="12" style="margin-top: 1px")
                    | Change image
                  input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 120px !important")
              v-card.my-3(outlined :height="resizeImageFileUrl ? '' : 203" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }")
                div(v-if="resizeImageFileUrl" align="center")
                  v-img(:src="resizeImageFileUrl" :aspect-ratio="16/9")
                div.fill-height(v-else)
                  div.d-flex.justify-center.align-end(style="height: 70%")
                    div
                      div.mb-2(align="center")
                        eva-icon(name="image-outline" :fill="$vuetify.theme.themes[$theme].primaryT32" height="38" width="38")
                      v-divider
                      div.file-layout.mb-4
                        v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload
                        input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 60px !important")
                  div.d-flex.justify-center.align-end(style="height: 30%")
                    div.mb-4
                      div.c1.basic600--text.text-center Max filesize 10 MB
                      div.c1.basic600--text.text-center Recommended image size 960x960 px
              
              .store-description.mt-4
                .label.mb-1.basic600--text.text-uppercase {{ $t('description_title') }}
                v-textarea.mt-2(v-model='description' :placeholder="$t('description.placeholder')" outlined dense persistent-hint counter background-color="basic200")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      manage-tenant-Images(v-if="openAddMoreImagesDialog" :open.sync="openAddMoreImagesDialog" :settings="settings")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ManageTenantImages from '@/components/dialogs/ManageTenantImages.vue'
import { resizeImage } from '@/utils'

export default {
  name: 'EditYezzaMallDialog',
  props: ['open', 'tenant', 'settings'],
  components: { ManageTenantImages },
  data: () => ({
    description: null,
    resizeImageFileUrl: '',
    resizeImageFile: null,
    isLoading: false,
    openAddMoreImagesDialog: false,
    categories: [],
    cetegorySearch: null,
    categoriesSearchLoading: false,
    categoryList: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    cetegorySearch () {
      if (this.categoryList.length != 0) {
        return
      }
      this.startSearchMembers()
    }
  },
  mounted () {
    this.description = this.tenant.description
    if (this.tenant.cover_image) {
      this.resizeImageFileUrl = this.tenant.cover_image.file
    }
    this.categories = this.tenant.categories
    this.startSearchMembers()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleAddMoreImagesDialog () {
      this.openAddMoreImagesDialog = true
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('branch', this.settings.branch.id)
      params.set('description', this.description)
      if (this.resizeImageFile) {
        params.append('cover_image', this.resizeImageFile)
      }
      this.categories.forEach(category => {
        params.append('categories', category.id)
      })
      this.axios.patch(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.mall_edited')])
          this.$emit('update:tenant', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'cover_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    startSearchMembers() {
      this.categoriesSearchLoading = true
      this.$axios.get(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/categories/?page_size=-1`)
        .then(resp => {
          if (resp.data.results) {
            this.categoryList = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => (this.categoriesSearchLoading = false))
    },
    removeSales (item) {
      let index = this.categories.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.categories.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "description_title": "Store Description",
    "cover_photo": "Cover Photo",
    "upload": "Upload",
    "edit": "Edit",
    "details": "Details",
    "product_name": {
      "label": "Name",
      "placeholder": "Write your store name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write store description here"
    },
    "has_inventory": "Has Inventory",
    "no_inventory": "No Inventory",
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    },
    "whos_selling": "Who's Selling",
    "add": "Add",
    "save": "Save"
  }
}
</i18n>
